"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _CSSTransition = _interopRequireDefault(require("react-transition-group/CSSTransition"));
var _SlideItem = _interopRequireDefault(require("./SlideItem.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Bitmaps = (0, _component.default)(function () {
  return import("./Bitmaps");
});
var Image = (0, _component.default)(function () {
  return import("./Image");
});
var Texts = (0, _component.default)(function () {
  return import("./Texts");
});
var Video = (0, _component.default)(function () {
  return import("./Video");
});
var SlideItem = function SlideItem(_ref) {
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
    bitmaps = _ref.bitmaps,
    counter = _ref.counter,
    duration = _ref.duration,
    hideTexts = _ref.hideTexts,
    itemsLength = _ref.itemsLength,
    media = _ref.media,
    mediaFormats = _ref.mediaFormats,
    playAnimation = _ref.playAnimation,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? true : _ref$show,
    showBlurredBackground = _ref.showBlurredBackground,
    stopAnimation = _ref.stopAnimation,
    texts = _ref.texts,
    textStyles = _ref.textStyles,
    webpFallback = _ref.webpFallback;
  var _ref2 = media || {},
    height = _ref2.height,
    mediaType = _ref2.mediaType,
    width = _ref2.width;
  var nodeRef = (0, _react.useRef)(null);
  var css = (0, _SlideItem.default)();
  return /*#__PURE__*/_react.default.createElement(_CSSTransition.default, {
    appear: true,
    className: (0, _clsx.default)(css.slideItem, "mco-animation-01__slide-item"),
    in: show,
    nodeRef: nodeRef,
    timeout: {
      appear: 100,
      enter: 100,
      exit: 800
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: nodeRef
  }, mediaType === "image" && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Image, {
    absoluteMediaURLs: absoluteMediaURLs,
    lazy: counter === 0 ? false : true,
    media: media,
    mediaFormats: mediaFormats,
    mode: showBlurredBackground ? "has-blurred-background" : "default",
    webpFallback: webpFallback
  }), showBlurredBackground && /*#__PURE__*/_react.default.createElement(Image, {
    absoluteMediaURLs: absoluteMediaURLs,
    lazy: true,
    media: media,
    mediaFormats: mediaFormats,
    mode: "background",
    webpFallback: webpFallback
  })), ["youtubevideo", "videofile"].indexOf(mediaType) > -1 && /*#__PURE__*/_react.default.createElement(Video, {
    absoluteMediaURLs: absoluteMediaURLs,
    media: media,
    playAnimation: playAnimation,
    show: show,
    stopAnimation: stopAnimation,
    type: mediaType
  }), !(0, _isEmpty.default)(texts) && !hideTexts && /*#__PURE__*/_react.default.createElement(Texts, {
    duration: duration,
    itemsLength: itemsLength,
    show: show,
    texts: texts,
    textStyles: textStyles
  }), !(0, _isEmpty.default)(bitmaps) && /*#__PURE__*/_react.default.createElement(Bitmaps, {
    bitmaps: bitmaps,
    height: height,
    show: show,
    width: width
  })));
};
var _default = SlideItem;
exports.default = _default;